import React, { useContext, useState } from 'react';
import classes from './OnboardingTitle.module.scss';
import classNames from 'classnames';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { IconsEnum } from '../../../constants/icons';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import { OnboardingContext } from '../states/OnboardingProvider';
import { OnboardingSteps } from '../OnboardingSteps';
import { InitialOnboardingSteps, OnboardingStaticContent } from '../constants/content';
import { PopupModal } from 'react-calendly';
import { CALENDLY_URL } from '../../../constants/calendly';

export type OnboardingTitleViewProps = {
  //
};

export const OnboardingTitleView = (_: OnboardingTitleViewProps): JSX.Element => {
  const { state, dispatch } = useContext(OnboardingContext);
  const [showCalendly, setShowCalendly] = useState<boolean>(false);
  const { version, activeStepIndex, expanded, progress, isCongrats, stepsCompleted } = state;
  const breakpoint = useBreakpoints();
  const { congrats: congratsData, paused: pausedData } = OnboardingStaticContent[`v${version}`];
  const activeStep =
    activeStepIndex > -1
      ? InitialOnboardingSteps[`v${version}`].find(step => step.key === progress[activeStepIndex].key)
      : undefined;
  let bookCallText: string;
  let congratsText: string;
  switch (breakpoint) {
    case 'small':
    case 'medium':
      bookCallText = 'Book a call';
      congratsText = congratsData.shorTitle;
      break;
    case 'tabletportrait':
      bookCallText = '';
      congratsText = congratsData.title;
      break;
    default:
      bookCallText = 'Book your onboarding call';
      congratsText = congratsData.title;
  }

  const isPaused = (!isCongrats && stepsCompleted) || !activeStep;
  // id={'onboardingTitleWrapper'} needs to be here to allow finding element in ref for height calculations in PostEditorMOdal.view.tsx
  return (
    <div className={classes.OnboardingTitle} id={'onboardingTitleWrapper'}>
      <div className={classNames(classes.Content, 'align-middle')}>
        <div className={classNames('cell', classes.OnboardingTitleCellPadding)}>
          <div className={'grid-x align-justify align-middle'}>
            <div className={'cell shrink'}>
              {isCongrats ? (
                <h5>{congratsText}</h5>
              ) : (
                <div className={'grid-x align-middle'}>
                  {version === 1 && activeStepIndex === 0 && ['xlarge', 'xxlarge'].includes(breakpoint) ? (
                    <div className={'cell shrink'}>
                      <h5>How SmarterQueue Works</h5>
                    </div>
                  ) : (
                    <></>
                  )}
                  {['small', 'medium'].includes(breakpoint) && !isCongrats ? (
                    isPaused ? (
                      <h5>{pausedData.stepName}</h5>
                    ) : (
                      <h5>{activeStep?.content.stepName || ''}</h5>
                    )
                  ) : null}
                  <OnboardingSteps className={'show-for-tablet-portrait'} />
                </div>
              )}
            </div>
            <div className={'cell shrink'}>
              <div className={'grid-x align-justify'}>
                <div className={'cell shrink align-middle'}>
                  <Button
                    action={() => setShowCalendly(true)}
                    className={classes.BookCallButton}
                    type={'button'}
                    variant={'hollow'}
                    size={'medium'}
                    color={ButtonColorsEnum.white}
                    rounded={true}
                    icon={{
                      side: breakpoint === 'tabletportrait' ? 'center' : 'left',
                      value: IconsEnum.call
                    }}>
                    {bookCallText}
                  </Button>
                </div>
                <div className={'cell shrink'}>
                  <div className={classes.ExpanderWrapper}>
                    <Button
                      action={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        dispatch({ type: 'toggleExpanded', payload: !expanded });
                      }}
                      type={'button'}
                      variant={'clear'}
                      size={'medium'}
                      color={ButtonColorsEnum.white}
                      className={classNames(classes.ArrowButton, expanded ? classes.ArrowButtonExpanded : null)}
                      icon={{ side: 'center', value: IconsEnum.arrowUp }}></Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PopupModal
        url={CALENDLY_URL}
        onModalClose={() => setShowCalendly(false)}
        open={showCalendly}
        rootElement={document.body}
      />
    </div>
  );
};
